(function () {

  const RULES = {
    'min-50': { type: 'min', qty: 50, message: 'Minimum order for this product is 50 units.' },
    'min-30': { type: 'min', qty: 30, message: 'Minimum order for this product is 30 units.' },
    'max-1':  { type: 'max', qty: 1,  message: 'Samples are limited to 1 unit per order.' }
  };

  const TIERS = [
    { min: 291, pct: 21 },
    { min: 271, pct: 20 },
    { min: 251, pct: 19 },
    { min: 231, pct: 18 },
    { min: 211, pct: 17 },
    { min: 191, pct: 16 },
    { min: 181, pct: 15 },
    { min: 171, pct: 14 },
    { min: 161, pct: 13 },
    { min: 151, pct: 12 },
    { min: 141, pct: 11 },
    { min: 131, pct: 10 },
    { min: 121, pct: 9  },
    { min: 111, pct: 8  },
    { min: 101, pct: 7  },
    { min: 91,  pct: 6  },
    { min: 81,  pct: 5  },
    { min: 71,  pct: 4  },
    { min: 61,  pct: 3  },
    { min: 51,  pct: 2  }
  ];

  function getCurrentPct(qty) {
    for (const t of TIERS) { if (qty >= t.min) return t.pct; }
    return 0;
  }

  function getNextTier(qty) {
    for (let i = TIERS.length - 1; i >= 0; i--) {
      if (TIERS[i].min > qty) return TIERS[i];
    }
    return null;
  }

  const CHECKOUT_BTN_SELECTOR = '#CartDrawer-Checkout, #checkout, button[name="checkout"]';

  function showToast(message) {
    let toast = document.getElementById('qty-rule-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'qty-rule-toast';
      toast.style.cssText = [
        'position:fixed', 'bottom:28px', 'left:50%',
        'transform:translateX(-50%) translateY(16px)',
        'background:#1a1a1a', 'color:#fff',
        'padding:14px 24px', 'border-radius:8px',
        'font-size:14px', 'font-family:inherit',
        'z-index:99999', 'max-width:380px',
        'width:calc(100% - 48px)', 'text-align:center',
        'opacity:0', 'transition:opacity 0.3s ease, transform 0.3s ease',
        'pointer-events:none', 'box-shadow:0 4px 24px rgba(0,0,0,0.28)',
        'line-height:1.5'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(16px)';
    }, 4500);
  }

  function showErrorBox(btn, errors) {
    const boxId = 'qty-rule-error-' + (btn.id || 'main');
    let box = document.getElementById(boxId);
    if (!box) {
      box = document.createElement('div');
      box.id = boxId;
      box.style.cssText = [
        'background:#fff5f5', 'border:1px solid #e53e3e',
        'color:#c53030', 'border-radius:6px',
        'padding:10px 14px', 'font-size:13px',
        'margin-top:10px', 'line-height:1.6'
      ].join(';');
      btn.parentNode.insertBefore(box, btn.nextSibling);
    }
    box.innerHTML = errors.map(e => `⚠ ${e}`).join('<br>');
    box.style.display = 'block';
  }

  function hideErrorBox(btn) {
    const boxId = 'qty-rule-error-' + (btn.id || 'main');
    const box = document.getElementById(boxId);
    if (box) box.style.display = 'none';
  }

  const tagCache = {};

  async function getProductTags(handle) {
    if (tagCache[handle] !== undefined) return tagCache[handle];
    try {
      const res = await fetch(`/products/${handle}.js`);
      const data = await res.json();
      tagCache[handle] = data.tags || [];
    } catch (e) { tagCache[handle] = []; }
    return tagCache[handle];
  }

  function findRule(tags) {
    for (const key of Object.keys(RULES)) {
      if (tags.includes(key)) return { key, ...RULES[key] };
    }
    return null;
  }

  async function validateCart() {
    let cart;
    try {
      const res = await fetch('/cart.js');
      cart = await res.json();
    } catch (e) { return []; }
    const errors = [];
    for (const item of cart.items) {
      const tags = await getProductTags(item.handle);
      const rule = findRule(tags);
      if (!rule) continue;
      if (rule.type === 'min' && item.quantity < rule.qty) {
        errors.push(`"${item.product_title}": minimum ${rule.qty} units required (you have ${item.quantity}).`);
      }
      if (rule.type === 'max' && item.quantity > rule.qty) {
        errors.push(`"${item.product_title}": maximum ${rule.qty} unit allowed (you have ${item.quantity}).`);
      }
    }
    return errors;
  }

  async function updateAllCheckoutButtons() {
    const buttons = document.querySelectorAll(CHECKOUT_BTN_SELECTOR);
    if (!buttons.length) return;
    const errors = await validateCart();
    buttons.forEach(btn => {
      if (errors.length > 0) {
        btn.disabled = true;
        btn.style.opacity = '0.5';
        btn.style.cursor = 'not-allowed';
        showErrorBox(btn, errors);
      } else {
        btn.disabled = false;
        btn.style.opacity = '';
        btn.style.cursor = '';
        hideErrorBox(btn);
      }
    });
  }

  let activeRule = null;

  function reapplyMinQty() {
    if (!activeRule || activeRule.type !== 'min') return;
    [100, 300, 600, 1000].forEach(delay => {
      setTimeout(() => {
        document.querySelectorAll('input.quantity__input[name="quantity"], input[name="quantity"]').forEach(input => {
          if (!input.value || parseInt(input.value) < activeRule.qty) {
            input.value = activeRule.qty;
          }
          input.setAttribute('min', activeRule.qty);
        });
      }, delay);
    });
  }

  async function initProductPageQty() {
    const handle = window.ShopifyAnalytics?.meta?.product?.handle || null;
    if (!handle) return;

    const tags = await getProductTags(handle);
    const rule = findRule(tags);
    if (!rule) return;

    activeRule = rule;

    if (rule.key === 'min-50') {
      const notice = document.getElementById('min-50-notice');
      if (notice) notice.style.display = 'block';
    }

    function applyRuleToInput(input) {
      if (rule.type === 'min') {
        input.setAttribute('min', rule.qty);
        if (!input.value || parseInt(input.value) < rule.qty) input.value = rule.qty;
        input.addEventListener('change', function () {
          if (parseInt(this.value) < rule.qty || isNaN(parseInt(this.value))) {
            this.value = rule.qty;
            showToast(rule.message);
          }
        });
        input.addEventListener('blur', function () {
          if (parseInt(this.value) < rule.qty || isNaN(parseInt(this.value))) this.value = rule.qty;
        });
      }
      if (rule.type === 'max') {
        input.setAttribute('max', rule.qty);
        if (parseInt(input.value) > rule.qty) input.value = rule.qty;
        input.addEventListener('change', function () {
          if (parseInt(this.value) > rule.qty || isNaN(parseInt(this.value))) {
            this.value = rule.qty;
            showToast(rule.message);
          }
        });
        input.addEventListener('blur', function () {
          if (parseInt(this.value) > rule.qty || isNaN(parseInt(this.value))) this.value = rule.qty;
        });
      }
    }

    document.querySelectorAll('input.quantity__input[name="quantity"], input[name="quantity"]')
      .forEach(applyRuleToInput);

    if (rule.type === 'min') {
      document.querySelectorAll('.quantity__button[name="minus"], button[name="minus"]').forEach(btn => {
        btn.addEventListener('click', function () {
          const input = this.closest('.quantity__wrapper, .quantity, .qty_atc')?.querySelector('input');
          if (!input) return;
          setTimeout(() => {
            if (parseInt(input.value) < rule.qty) {
              input.value = rule.qty;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }, 50);
        });
      });
    }

    if (rule.type === 'max') {
      document.querySelectorAll('.quantity__button[name="plus"], button[name="plus"]').forEach(btn => {
        btn.addEventListener('click', function () {
          const input = this.closest('.quantity__wrapper, .quantity, .qty_atc')?.querySelector('input');
          if (!input) return;
          setTimeout(() => {
            if (parseInt(input.value) > rule.qty) {
              input.value = rule.qty;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              showToast(rule.message);
            }
          }, 50);
        });
      });
    }

    const qtyContainer = document.querySelector(
      '.quantity__wrapper, .product-form__quantity, .qty_atc, [id*="Quantity-template"]'
    )?.parentElement;

    // ─── ПРИХОВАНО: Minimum order hint ───────────────────────────
    // if (qtyContainer && !document.getElementById('qty-rule-hint')) { ... }

    // ─── ПРИХОВАНО: Quantities under X note ──────────────────────
    // if (rule.type === 'min' && qtyContainer && ...) { ... }

    // ─── ПРИХОВАНО: Add X more for discount hint ─────────────────
    // if (rule.key === 'min-50' && qtyContainer) { ... }

  }

  async function checkAddToCart(form) {
    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return true;
    const qtyInput = form.querySelector('[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
    const handle = window.ShopifyAnalytics?.meta?.product?.handle || null;
    if (!handle) return true;
    const tags = await getProductTags(handle);
    const rule = findRule(tags);
    if (!rule) return true;
    if (rule.type === 'min' && qty < rule.qty) { showToast(rule.message); return false; }
    if (rule.type === 'max' && qty > rule.qty) { showToast(rule.message); return false; }
    return true;
  }

  function init() {

    initProductPageQty();

    // Re-apply minimum quantity when variant changes
    document.addEventListener('change', function(e) {
      if (
        (e.target.name && e.target.name.startsWith('options[')) ||
        e.target.name === 'id'
      ) {
        reapplyMinQty();
      }
    });

    // Also catch variant-selects custom element events
    document.addEventListener('variant:change', reapplyMinQty);
    document.addEventListener('variantChange', reapplyMinQty);

    document.addEventListener('submit', async function (e) {
      const form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      const allowed = await checkAddToCart(form);
      if (!allowed) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);

    document.addEventListener('click', async function (e) {
      const btn = e.target.closest(CHECKOUT_BTN_SELECTOR);
      if (!btn) return;
      if (btn.disabled) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      const errors = await validateCart();
      if (errors.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showToast(errors[0]);
        showErrorBox(btn, errors);
      }
    }, true);

    document.addEventListener('change', function (e) {
      const isCart =
        e.target.matches('[name="updates[]"]') ||
        e.target.closest('#CartDrawer') ||
        e.target.closest('#main-cart-items') ||
        e.target.closest('.cart-drawer');
      if (isCart) setTimeout(updateAllCheckoutButtons, 800);
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.quantity__button') || e.target.closest('.quantity-popover')) {
        setTimeout(updateAllCheckoutButtons, 600);
      }
    });

    const observer = new MutationObserver(function (mutations) {
      let check = false;
      for (const m of mutations) {
        if (m.type === 'attributes') {
          const t = m.target;
          if (t.id === 'CartDrawer' || t.classList?.contains('cart-drawer')) check = true;
        }
        if (m.type === 'childList') {
          for (const node of m.addedNodes) {
            if (node.nodeType === 1 &&
                (node.id?.includes('Cart') || node.querySelector?.('#CartDrawer-Checkout, #checkout'))) {
              check = true;
            }
          }
        }
      }
      if (check) setTimeout(updateAllCheckoutButtons, 350);
    });

    observer.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['open', 'class', 'aria-hidden', 'aria-expanded']
    });

    setTimeout(updateAllCheckoutButtons, 600);

    document.addEventListener('cart:refresh', () => setTimeout(updateAllCheckoutButtons, 500));
    document.addEventListener('cart:updated', () => setTimeout(updateAllCheckoutButtons, 500));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();